import VectorLayer from 'ol/layer/Vector';

//works on point geometries only, if radiusFunc is passed
export default function({map, pixel, layers, radiusFunc, pie_donut_treshold = 9999999}) {

        //mousePos = event.pixel;

        var mousePos = pixel;

        var extent = map.getView().calculateExtent();

        var features = [];

        if(typeof radiusFunc == 'undefined') {

            var feature = false;
            map.forEachFeatureAtPixel(pixel, (pixelFeature, layer)=>{
                
                if(layers.indexOf(layer) > -1) {
                    feature = pixelFeature;
                }

            }, (layer)=>{

                if(layers.indexOf(layer) > -1) {
                    return true;
                } else {
                    return false;
                }
            });

            return feature;
        }

    //    var layers = map.getLayers().getArray();
        var radiusPrev = 999999;
        var featureSelected = null;
        for (var i = layers.length - 1; i >= 0; i--) {
            
           
            if(layers[i] instanceof VectorLayer 
                && layers[i].getVisible() 
               ) { // && layers[i].getProperties().group === 'student_schools'


                layers[i].getSource().forEachFeatureIntersectingExtent(extent, function(feature) {

                    var centerpixel = map.getPixelFromCoordinate(feature.getGeometry().getCoordinates());
                //  features.push(feature);
                /*    

                    var total = hf.countProp(feature, 'total');
                    var total2 = feature.getProperties().total;
                    var radius = (Math.sqrt(total / Math.PI)) * (sliderStateStudents.getPercent() / 25);
                */

                    var radius = radiusFunc(feature);


                    var clickDistance = Math.sqrt((centerpixel[0]-pixel[0])*(centerpixel[0]-pixel[0]) + (centerpixel[1]-pixel[1])*(centerpixel[1]-pixel[1]));
                    if (clickDistance < radius) {

                        if(radiusPrev < radius) {
                            return;
                        }

                        if(radius > pie_donut_treshold) { //if donut, verify if not clicked inside
                            var cutCircleRadius = radius * 0.8;

                            if(clickDistance < cutCircleRadius) {

                                return;
                            }
                        }

                        featureSelected = feature;

                        radiusPrev = radius;
                    }

                });
            }
        }

    //    var interactionFeatures = selectInteraction.getFeatures();
    //    interactionFeatures.clear();

        if(featureSelected) {
        //    interactionFeatures.push(featureSelected);
            return featureSelected;
        }
        
        return false;
}


// WEBPACK FOOTER //
// ./C:/Users/viesis/Desktop/deportacijas/src/map/findFeatureByPixel.js